import React from "react";
import deltalogo from "../../../assets/Delta_logo 1.svg";
import luftlogo from "../../../assets/luftanca.svg";

import emirateslogo from "../../../assets/emirates.svg";
import israillogo from "../../../assets/El Al Israeli Airlines_idX605dffW_0.svg";
import britishlogo from "../../../assets/British Airways_idehCwhP8m_0.svg";
import unitedlogo from "../../../assets/United Airlines_Logo_1.png";
import francelogo from "../../../assets/Air France_idgn4MvQdM_0.svg";
import Qatar from "../../../assets/Qatar.png";
import Singapore from "../../../assets/Singapore.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
const AirlineBrands = () => {
  return (
    <div className="container-wrapper brand-section">
      <h1 className="header text-center" style={{ padding: "0px 10%" }}>
        We’ve helped travelers claim compensation from these airlines
      </h1>
      <div className="partner-airline-wrapper">
        <Swiper
          style={{ padding: "0px 20px" }}
          spaceBetween={20}
          slidesPerView={1} // Default for mobile
          loop={true}
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 4 },
          }}
          modules={[Autoplay]}
          className="mySwiper"
        >
          <SwiperSlide>
            <div className="partner-box">
              <img src={deltalogo} alt="Slide 1" />
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="partner-box">
              <img src={luftlogo} alt="Slide 1" />
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="partner-box">
              <img src={emirateslogo} alt="Slide 1" />
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="partner-box">
              <img src={Qatar} alt="Slide 1" />
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="partner-box">
              <img src={Singapore} alt="Slide 1" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="partner-box">
              <img src={luftlogo} alt="Slide 1" />
            </div>
          </SwiperSlide>

          {/* <SwiperSlide>
            <div className="partner-box">
              <img src={unitedlogo} alt="Slide 1" />
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="partner-box">
              <img src={francelogo} alt="Slide 1" />
            </div>
          </SwiperSlide> */}
        </Swiper>
      </div>

      {/* mobile view */}

      {/* <div className="mobile-wrapper brand-wrapper">
        <div className="brand-image-wrapper">
          <img src={deltalogo} />
          <img src={luftlogo} />
        </div>

        <img src={emirateslogo} />
        <div className="brand-image-wrapper">
          <img src={singapurlogo} />
          <img src={qatarlogo} />
        </div>
      </div> */}
    </div>
  );
};

export default AirlineBrands;
